import { TraV1 } from './v1/tra-v1';

function jsonParse(json: string): Record<string, unknown> | undefined {
    try {
        const data: unknown = json ? JSON.parse(json) : undefined;
        if (typeof data !== 'object') {
            return undefined;
        }
        return data as Record<string, unknown>;
    } catch (e) {
        return undefined;
    }
}

export function emptyTRA(): TraV1 {
    return new TraV1();
}

export function parseTRA(
    json: string,
    callback?: () => void,
): {
    dataVersion?: number;
    data: TraV1; // | TraV2 | TraV3 etc.;
} {
    const latestTra = new TraV1(callback);
    const tras = [new TraV1(callback)];
    const data = jsonParse(json);

    if (!data) {
        return { data: latestTra };
    }

    tras.forEach((tra) => {
        tra.parse(data);
    });

    const validTra = tras.find((tra) => !tra.error);
    const result = validTra ?? tras[tras.length - 1];

    return { dataVersion: data.version as number, data: result };
}
